export function spliceStateVar (stateVar, stateVarFn, i) {
    const copyDecks = [...stateVar];
    copyDecks.splice(i, 1);
    stateVarFn(copyDecks);
}
